import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { serverError } from '@/utils/serverError';

export const paymentDetailsEditMixin = {
  mixins: [formMixin, notificationsMixin],

  computed: mapState({
    stateData: state => state.payment.data
  }),

  beforeMount() {
    this.setData();
  },

  methods: {
    // @vuese
    // Zapisuje dane płatności
    saveData() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }
      const id = this.$schema.id.$getData();
      this.$store
        .dispatch('payment/update', this.$schema.$getData())
        .then(() => {
          this.notifySuccess(Successes.PAYMENT_DATA_SAVED);
          return this.$store.dispatch('payment/list', {
            count: -1,
            start: 0,
            packId: parseInt(this.$route.params.packId),
            structureIds: this.$store.state.auth.nodes.map(node => node.id)
          });
        })
        .then(paymentsResponse => paymentsResponse.list.find(payment => payment.id === id))
        .then(payment => {
          this.$store.commit('payment/setEntity', payment);
          this.$emit('close');
        })
        .catch(err => this.notifyError(serverError(err)));
    },

    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.$setDefault();
      this.$schema.$setData(
        {
          ...this.stateData,
          data: {
            ...this.stateData?.data,
            contractorId: null,
            contractorAddressId: null,
            contractorBankAccountId: null
          }
        },
        undefined,
        true
      );
      this.$schema.$reset();
    }
  }
};
